module.exports = __webpack_public_path__ + "img/news-no-msg.74b9289b.png";